import { API, Competition } from "@brg/api";
import { Colors, FlexBox, MEDIA } from "@brg/ui";
import { COMPETITION_TYPE, isNewDafesChoiceCompetitionType } from "_competition/const";
import { DafesProjectType } from "_competition/pages/AllCompetitionsPage/types";
import { LayoutConst } from "core";
import { FC, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import {STATUSES} from "../../../../../_competition/const";
import { CoverDafesIcon } from "./CoverDafesIcon";

export const Container = styled.div<{isCompetitionPage?: boolean}>`
  width: 270px;
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;

 ${({ isCompetitionPage }) => isCompetitionPage && css`
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      width: 204px;
    }
 `}
 
  @media (max-width: ${LayoutConst.screen.l_12}px) {
    width: 204px;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    width: 168px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 168px;
  }
  ${({ isCompetitionPage }) => isCompetitionPage && css`
   @media (max-width: ${LayoutConst.screen.md}px) {
    width: 100%;
  }
 `}
  @media (max-width: 768px) {
    width: 174px;
    height: 100%;
    min-height: 243px;
  }
  @media (max-width: ${LayoutConst.screen.s + "px"}) {
    height: ${LayoutConst.competitionCard.s.h + "px"};
    width: ${(LayoutConst.competitionCard.s.w - 4) / 2 + "px"};
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {

    ${() => {
      const width = 100;
      const padding = 20;
      const calculatedWidth = `calc(((${width}vw - ${padding}px) - 4px) / 2)`;
      const calculatedHeight = `calc((${width}vw - ${padding}px) * 0.680)`;
      return css`
        width: ${calculatedWidth};
        height: ${calculatedHeight};
        max-width: ${calculatedWidth};
        max-height: ${calculatedHeight};
        min-width: ${calculatedWidth};
        min-height: ${calculatedHeight};
        img {
          object-fit: cover;
        }
      `;
    }}
  }
`;

export const TopSection = styled.div<{background?: string, color?: string, isCompetitionPage?: boolean, $isNewDafesChoice?: boolean}>`
  background-color: ${Colors.galBlack100};
  color: ${({ color }) => color};
  flex: 1;
  display: flex;
  padding: 24px 24px 6px 32px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
    gap: 10px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    padding: 16px 16px 4px 16px;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    padding: 16px 16px 4px 16px;
  }

  @media (max-width: 500px) {
    padding: 12px 12px 4px 12px;
  }
`;
export const CoverDafesLogo = styled.div`
  width: 100px;
  height: 22px;
  flex-shrink: 0;
  align-self: flex-start;

  svg {
    display: block;
    width: 100%;
    height: 100%;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 80px;
    height: 17px;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    width: 64px;
    height: 14px;
  }
`;
export const BottomSection = styled.div<{ background: string, isCompetitionPage?: boolean }>`
  background-color: ${({ background }) => background};
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 24px 24px 32px 32px;
  justify-content: center;
  align-items: flex-start;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    padding: 24px 16px 32px 16px;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    padding: 16px 16px 32px 16px;
  }

  @media (max-width: 500px) {
    padding: 12px 16px 32px 16px;
  }
`;
export const BestText = styled.div<{isCompetitionPage?: boolean}>`
  font-size: 70px;
  font-weight: 500;
  line-height: 65px; /* 92.857% */
  text-transform: uppercase;
  color: inherit;
  font-family: 'Druk Cy', sans-serif;
  font-feature-settings: 'liga' off, 'clig' off;
   ${({ isCompetitionPage }) => isCompetitionPage && css`
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
       font-size: 59px;
        font-weight: 500;
        line-height: 54px;
      }
  `}
  @media (max-width: ${LayoutConst.screen.l_12}px) {
      font-size: 59px;
        font-weight: 500;
        line-height: 54px;
    }
  @media (max-width: ${LayoutConst.screen.m + "px"}){
    font-size: 45px;
    font-weight: 500;
    line-height: 45px;
  }
   @media (max-width: ${LayoutConst.screen.s - 1 + "px"}){
            font-size: 49px;
        font-weight: 500;
        line-height: 49px;
    }

  }
`;

export const CoverTopTexts = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
`;

const coverTopTextStyles = css`
  text-align: right;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: "HSE Condensed", "HSE Sans", sans-serif;
  font-size: 62px;
  font-style: normal;
  font-weight: 500;
  line-height: 62px;
  text-transform: uppercase;
  width: 100%;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 50px;
    line-height: 45px;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    font-size: 39px;
    line-height: 34px;
  }

  @media (max-width: 950px) {
    font-size: 37px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 60px;
    line-height: 60px;
  }

  @media (max-width: 500px) {
    font-size: 35px;
    line-height: 30px;
  }
`;

export const DafesCoverBestText = styled.div`
  ${coverTopTextStyles}
  color: ${Colors.gal};
`;

export const DafesCoverCategoryText = styled.div<{ $color: string }>`
  ${coverTopTextStyles}
  color: ${({ $color }) => $color};
`;
export const Text = styled.div<{isCompetitionPage?: boolean}>`
  font-size: 70px;
  font-weight: 500;
  line-height: 65px; /* 92.857% */
  text-transform: uppercase;
  color: #fff;
  font-family: 'Druk Cy', sans-serif;
  font-feature-settings: 'liga' off, 'clig' off;
   ${({ isCompetitionPage }) => isCompetitionPage && css`
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 59px;
        font-weight: 500;
        line-height: 54px
      }
  `}
  @media (max-width: ${LayoutConst.screen.l_12}px) {
    font-size: 59px;
        font-weight: 500;
        line-height: 54px;
    }
 @media (max-width: ${LayoutConst.screen.m + "px"}){
    font-size: 45px;
    font-weight: 500;
    line-height: 45px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}){
            font-size: 49px;
        font-weight: 500;
        line-height: 49px;
    }

  }
      
`;

const NEW_COVER_FROM_YEAR = 2026;
const NEW_COVER_FROM_MONTH = 5;

const isNewDafesCoverDesign = (competition?: Competition): boolean => {
  const year = Number(competition?.ratingSettings?.year);
  const month = Number(competition?.ratingSettings?.month);

  if (!Number.isFinite(year) || !Number.isFinite(month)) {
    return false;
  }

  return year > NEW_COVER_FROM_YEAR || (year === NEW_COVER_FROM_YEAR && month >= NEW_COVER_FROM_MONTH);
};

export const LegacyTopSection = styled.div<{background?: string, color?: string, isCompetitionPage?: boolean, $isNewDafesChoice?: boolean}>`
  background-color: ${({ background }) => background};
  color: ${({ color }) => color};
  flex: 1;
  display: flex;
  flex-direction: ${({ $isNewDafesChoice }) => $isNewDafesChoice ? 'column' : 'row'};
  justify-content: flex-end;
  align-items: flex-end;
  padding: 24px 24px 16px;
  ${({ isCompetitionPage }) => isCompetitionPage && css`
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      padding: 20px 20px 12px;
    }
 `}
  @media (max-width: ${LayoutConst.screen.l_12}px) {
    padding: 20px 20px 12px;
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    padding: 8px 16px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
    padding: 16px 16px 12px;
  }
`;

export const LegacyBottomSection = styled.div<{ background: string, isCompetitionPage?: boolean }>`
  background-color: ${({ background }) => background};
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  padding: 20px 24px 16px;
   ${({ isCompetitionPage }) => isCompetitionPage && css`
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        padding: 14px 20px 12px;
      }
  `}
  @media (max-width: ${LayoutConst.screen.l_12}px) {
    padding: 14px 20px 12px;
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    padding: 8px 16px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
    padding: 16px 18px 16px;
  }
  @media (max-width: ${LayoutConst.screen.xsm + "px"}) {
    padding: 10px 18px 10px;
  }
`;

export const LegacyDafesCoverBestText = styled.div`
  font-size: 70px;
  font-weight: 500;
  line-height: 65px;
  text-transform: uppercase;
  color: inherit;
  font-family: 'Druk Cy', sans-serif;
  font-feature-settings: 'liga' off, 'clig' off;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 53px;
    line-height: 50px;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    font-size: 46px;
    line-height: 45px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
    font-size: 40px;
    line-height: 35px;
  }
`;

export const LegacyDafesCoverText = styled.div`
  font-size: 70px;
  font-weight: 500;
  line-height: 65px;
  text-transform: uppercase;
  color: #fff;
  font-family: 'Druk Cy', sans-serif;
  font-feature-settings: 'liga' off, 'clig' off;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 53px;
    line-height: 50px;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    font-size: 46px;
    line-height: 45px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
    font-size: 40px;
    line-height: 35px;
  }
`;
export const DafesCoverText = styled.div`
  color: ${Colors.gal};
  text-align: right;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: "HSE Condensed", "HSE Sans", sans-serif;
  font-size: 62px;
  font-style: normal;
  font-weight: 500;
  line-height: 55px;
  text-transform: uppercase;
  width: 100%;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 50px;
    line-height: 45px;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    font-size: 39px;
    line-height: 39px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 60px;
    line-height: 60px;
  }

  @media (max-width: 500px) {
    font-size: 35px;
    line-height: 35px;
  }
`;
export const PlateContainer = styled(FlexBox)<{isGridPlate?: boolean}>`
  width: ${({ isGridPlate }) => (isGridPlate ? '80px' : '160px')};
  height: ${({ isGridPlate }) => (isGridPlate ? '80px' : '160px')};
  flex-direction: column;
  flex-shrink: 0;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    width: ${({ isGridPlate }) => (isGridPlate ? '60px' : '120px')};
    height: ${({ isGridPlate }) => (isGridPlate ? '60px' : '120px')};
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    width: ${({ isGridPlate }) => (isGridPlate ? '60px' : '100px')};
    height: ${({ isGridPlate }) => (isGridPlate ? '60px' : '100px')};
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    width: ${({ isGridPlate }) => (isGridPlate ? '56px' : '88px')};
    height: ${({ isGridPlate }) => (isGridPlate ? '56px' : '88px')};
  }
`;
export const PlateTopSection = styled(FlexBox)<{isGridPlate?: boolean}>`
  height: ${({ isGridPlate }) => (isGridPlate ? '50px' : '100px')};
  flex: none;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background: ${Colors.galBlack100};
  color: ${Colors.white};
  padding: ${({ isGridPlate }) => (isGridPlate ? '8px 6px 4px 6px' : '16px 12px 8px 12px')};

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    height: ${({ isGridPlate }) => (isGridPlate ? '39px' : '75px')};
    padding: ${({ isGridPlate }) => (isGridPlate ? '6px 5px 3px 5px' : '12px 10px 6px 10px')};
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    height: ${({ isGridPlate }) => (isGridPlate ? '39px' : '63px')};
    padding: ${({ isGridPlate }) => (isGridPlate ? '6px 5px 3px 5px' : '10px 8px 5px 8px')};
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    height: ${({ isGridPlate }) => (isGridPlate ? '32px' : '54px')};
    padding: ${({ isGridPlate }) => (isGridPlate ? '4px 3.333px 2px 3.333px' : '8px 8px 4px 8px')};
  }
`;
const plateTopTextStyles = css`
  text-align: right;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: "HSE Condensed", "HSE Sans", sans-serif;
  font-size: 19px;
  font-style: normal;
  font-weight: 500;
  line-height: 19px;
  text-transform: uppercase;
  white-space: nowrap;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 14px;
    line-height: 14.012px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 9.333px;
    line-height: 9.342px;
  }
`;

const plateTopTextProjectStyles = css`
  font-size: 38px;
  line-height: 38px;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 28px;
    line-height: 28px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 24px;
    line-height: 24px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 16px;
    line-height: 16px;
  }
`;

export const PlateChoiceText = styled.div<{isGridPlate?: boolean}>`
  color: ${Colors.white};
  ${plateTopTextStyles};
  ${({ isGridPlate }) => !isGridPlate && plateTopTextProjectStyles};

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: ${({ isGridPlate }) => (isGridPlate ? '11px' : '16px')};
    line-height: ${({ isGridPlate }) => (isGridPlate ? '11px' : '16px')};
  }
  
`;

export const PlateBestText = styled.div<{ isGridPlate?: boolean; $accentColor: string }>`
  color: ${({ $accentColor }) => $accentColor};
  ${plateTopTextStyles};
  ${({ isGridPlate }) => !isGridPlate && plateTopTextProjectStyles};

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: ${({ isGridPlate }) => (isGridPlate ? '11px' : '16px')};
    line-height: ${({ isGridPlate }) => (isGridPlate ? '11px' : '16px')};
  }
`;
export const PlateBottomSection = styled.div<{ isGridPlate?: boolean; $accentColor: string }>`
  height: ${({ isGridPlate }) => (isGridPlate ? '30px' : '60px')};
  flex: none;
  background-color: ${({ $accentColor }) => $accentColor};
  display: flex;
  padding: ${({ isGridPlate }) => (isGridPlate ? '9px 6px 8px 6px' : '18px 12px 16px 12px')};
  justify-content: center;
  align-items: flex-start;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    height: ${({ isGridPlate }) => (isGridPlate ? '21px' : '45px')};
    padding: ${({ isGridPlate }) => (isGridPlate ? '7px 5px' : '14px 10px')};
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    height: ${({ isGridPlate }) => (isGridPlate ? '21px' : '37px')};
    padding: ${({ isGridPlate }) => (isGridPlate ? '7px 5px' : '12px 8px')};
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    height: ${({ isGridPlate }) => (isGridPlate ? '24px' : '34px')};
    padding: ${({ isGridPlate }) => (isGridPlate ? '4.667px 3.333px' : '8px 8px 4px 8px')};
  }
`;

export const PlateText = styled.div<{isGridPlate?: boolean}>`
  color: ${Colors.white};
  text-align: right;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: "HSE Condensed", "HSE Sans", sans-serif;
  font-size: ${({ isGridPlate }) => (isGridPlate ? '15px' : '30px')};
  font-style: normal;
  font-weight: 500;
  line-height: ${({ isGridPlate }) => (isGridPlate ? '15px' : '30px')};
  text-transform: uppercase;
  white-space: nowrap;
  width: 100%;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: ${({ isGridPlate }) => (isGridPlate ? '11px' : '22px')};
    line-height: ${({ isGridPlate }) => (isGridPlate ? '11px' : '22px')};
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: ${({ isGridPlate }) => (isGridPlate ? '11px' : '19px')};
    line-height: ${({ isGridPlate }) => (isGridPlate ? '11px' : '19px')};
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: ${({ isGridPlate }) => (isGridPlate ? '11px' : '16px')};
    line-height: ${({ isGridPlate }) => (isGridPlate ? '11px' : '16px')};
  }
`;

const LegacyPlateContainer = styled(FlexBox)<{ $isNewDafes?: boolean }>`
  width: 160px;
  height: ${({ $isNewDafes }) => ($isNewDafes ? '160px' : '172px')};
  flex-direction: column;
  @media (max-width: ${LayoutConst.screen.mac13}px) {
    width: 120px;
    height: ${({ $isNewDafes }) => ($isNewDafes ? '120px' : '129px')};
  }
  @media (max-width: ${LayoutConst.screen.m + "px"}) {
    width: 100px;
    height: ${({ $isNewDafes }) => ($isNewDafes ? '100px' : '107px')};
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
    width: 88px;
    height: ${({ $isNewDafes }) => ($isNewDafes ? '88px' : '94px')};
  }
`;
const LegacyPlateTopSection = styled(FlexBox)<{background?: string, color?: string, $isNewDafes?: boolean}>`
  height: 50%;
  background: ${({ background }) => background};
  color: ${({ color }) => color};
  padding: ${({ $isNewDafes }) => $isNewDafes ? '10px 16px 5px' : '16px 16px 8px'};
  justify-content: flex-end;
  flex: 1;
  @media (max-width: ${LayoutConst.screen.m + "px"}) {
   padding: 8px 10px 4px 10px;
  }
`;
const LegacyPlateBottomSection = styled.div<{ background: string, $isNewDafes?: boolean }>`
  background-color: ${({ background }) => background};
  padding: 16px;
  flex: 2;
  @media (max-width: ${LayoutConst.screen.m + "px"}) {
    padding: 10px;
  }
  @media ${MEDIA.MOBILE} {
    padding: ${({ $isNewDafes }) => $isNewDafes ? '8px' : '10px'};
  }
`;
const LegacyPlateBestText = styled.div<{ $compact?: boolean, $isNewDafes?: boolean }>`
  font-size: ${({ $compact, $isNewDafes }) => $isNewDafes || $compact ? '30px' : '40px'};
  line-height: ${({ $isNewDafes }) => $isNewDafes ? '40px' : '92.857%'};
  font-weight: 500;
  text-transform: uppercase;
  text-align: right;
  color: inherit;
  font-family: 'Druk Cy', sans-serif;
  font-feature-settings: 'liga' off, 'clig' off;
  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: ${({ $isNewDafes }) => $isNewDafes ? '23px' : '38px'};
    line-height: ${({ $isNewDafes }) => $isNewDafes ? '30px' : '92.857%'};
    }
  @media (max-width: ${LayoutConst.screen.l}){
      font-size: ${({ $isNewDafes }) => $isNewDafes ? '19px' : '28px'};
      line-height: ${({ $isNewDafes }) => $isNewDafes ? '25px' : '92.857%'};
    }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}){
        font-size: ${({ $isNewDafes }) => $isNewDafes ? '17px' : '27px'};
        line-height: ${({ $isNewDafes }) => $isNewDafes ? '22px' : '92.857%'};
      }
  }
`;
const LegacyPlateText = styled.div<{ $isNewDafes?: boolean }>`
  font-size: ${({ $isNewDafes }) => $isNewDafes ? '43px' : '40px'};
  font-weight: 500;
  line-height: ${({ $isNewDafes }) => $isNewDafes ? '40px' : '92.857%'};
  text-transform: uppercase;
  text-align: right;
  color: #fff;
  font-family: 'Druk Cy', sans-serif;
  font-feature-settings: 'liga' off, 'clig' off;
  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: ${({ $isNewDafes }) => $isNewDafes ? '32px' : '38px'};
  line-height: ${({ $isNewDafes }) => $isNewDafes ? '30px' : '92.857%'};
  }
  @media (max-width: ${LayoutConst.screen.l}){
      font-size: ${({ $isNewDafes }) => $isNewDafes ? '27px' : '28px'};
      line-height: ${({ $isNewDafes }) => $isNewDafes ? '25px' : '92.857%'};
    }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}){
        font-size: ${({ $isNewDafes }) => $isNewDafes ? '24px' : '27px'};
        line-height: ${({ $isNewDafes }) => $isNewDafes ? '22px' : '92.857%'};
      }
  }
      
`;

export const GridPlateContainer = styled(FlexBox)<{ $isNewDafes?: boolean }>`
  width: 80px;
  height: ${({ $isNewDafes }) => ($isNewDafes ? '80px' : '86px')};
  flex-direction: column;
  @media (max-width: ${LayoutConst.screen.mac13}px) {
    width: 60px;
    height: ${({ $isNewDafes }) => ($isNewDafes ? '60px' : '64px')};
  }
  @media (max-width: ${LayoutConst.screen.l}px) {
    width: 60px;
    height: ${({ $isNewDafes }) => ($isNewDafes ? '60px' : '64px')};
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
    width: 56px;
    height: ${({ $isNewDafes }) => ($isNewDafes ? '56px' : '63px')};
  }
`;


export const GridTopSection = styled(FlexBox)<{ background?: string, color?: string}>`
  height: 30px;
  background: ${({ background }) => background};
  color: ${({ color }) => color};
  padding: 6px 6px 4px;
  justify-content: flex-end;
  flex: 1;
  @media (max-width: ${LayoutConst.screen.l_12}px) {
  }
  @media (max-width: ${LayoutConst.screen.m + "px"}) {
   padding: 4px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
   padding: 6px 6px 4px;
  }
   @media (max-width: ${LayoutConst.screen.sm + "px"}) {
     padding: 5px 4px 2px;
  }
`;

export const GridBottomSection = styled.div<{ background: string }>`
  background-color: ${({ background }) => background};
  padding: 6px;
  flex: 2;
  @media (max-width: ${LayoutConst.screen.l_12}px) {
  
  }
  @media (max-width: ${LayoutConst.screen.m + "px"}) {
    padding: 4px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
    padding: 6px;
  }
  @media (max-width: ${LayoutConst.screen.sm + "px"}) {
     padding: 4px;
  }
`;

export const GridBestText = styled.div<{ $isNewDafes?: boolean }>`
  font-size: ${({ $isNewDafes }) => $isNewDafes ? '15px' : '22px'};
  line-height: ${({ $isNewDafes }) => $isNewDafes ? '19px' : '92.857%'};
  font-weight: 500;
  text-transform: uppercase;
  text-align: right;
  color: inherit;
  font-family: 'Druk Cy', sans-serif;
  font-feature-settings: 'liga' off, 'clig' off;
  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: ${({ $isNewDafes }) => $isNewDafes ? '11px' : '16px'};
    line-height: ${({ $isNewDafes }) => $isNewDafes ? '14px' : '92.857%'};
  }
  @media (max-width: ${LayoutConst.screen.l}){
    font-size: ${({ $isNewDafes }) => $isNewDafes ? '10px' : '14px'};
    line-height: ${({ $isNewDafes }) => $isNewDafes ? '14px' : '92.857%'};
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}){
    font-size: ${({ $isNewDafes }) => $isNewDafes ? '8px' : '11px'};
    line-height: ${({ $isNewDafes }) => $isNewDafes ? '10px' : '92.857%'};
      }
  }

  }
`;

export const GridText = styled.div<{ $isNewDafes?: boolean }>`
  font-size: ${({ $isNewDafes }) => $isNewDafes ? '21px' : '22px'};
  font-weight: 500;
  line-height: ${({ $isNewDafes }) => $isNewDafes ? '19px' : '92.857%'};
  text-transform: uppercase;
  text-align: right;
  color: #fff;
  font-family: 'Druk Cy', sans-serif;
  font-feature-settings: 'liga' off, 'clig' off;
  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: ${({ $isNewDafes }) => $isNewDafes ? '16px' : '21px'};
    line-height: ${({ $isNewDafes }) => $isNewDafes ? '14px' : '92.857%'};
  }
  @media (max-width: ${LayoutConst.screen.l}){
    font-size: ${({ $isNewDafes }) => $isNewDafes ? '15px' : '14px'};
    line-height: ${({ $isNewDafes }) => $isNewDafes ? '14px' : '92.857%'};
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}){
    font-size: ${({ $isNewDafes }) => $isNewDafes ? '11px' : '22px'};
    line-height: ${({ $isNewDafes }) => $isNewDafes ? '10px' : '92.857%'};
      }
  }
      
`;

const DAFES_CHOICE_BOTTOM_COLOR = '#8E7CC3';
const DAFES_PLUS_BOTTOM_COLOR = '#2D2D2D';

const COVER_BOTTOM_COLORS: Record<DafesProjectType, string> = {
  [DafesProjectType.art]: '#FF6BFD',
  [DafesProjectType.fashion]: '#FF8B00',
  [DafesProjectType.design]: '#F00',
  [DafesProjectType.education]: '#5D98FF',
  [DafesProjectType.startups]: '#4EF100',
  [DafesProjectType.dafesPlus]: '#F00',
};

const getCoverBottomColor = (type: DafesProjectType): string => {
  return COVER_BOTTOM_COLORS[type] ?? COVER_BOTTOM_COLORS[DafesProjectType.design];
};

const DAFES_TOP_BLOCK_STYLES = {
  background: '#F6C744',
  color: '#151514',
};

enum MonthColors {
  Winter = "#8C6FDD",
  Sprint = "#EC5FB1",
  Summer = "#49A13F",
  Autumn = "#EB5829",
}

function getMonthColor(monthNumber: number): string {
  
  switch (monthNumber) {
    case 11:
    case 0:
    case 1:
      return MonthColors.Winter;
    case 2:
    case 3:
    case 4:
      return MonthColors.Sprint;
    case 5:
    case 6:
    case 7:
      return MonthColors.Summer;
    case 8:
    case 9:
    case 10:
      return MonthColors.Autumn;
    default:
      return "#000000";
  }
}

const getTopBlockStyles = (type: DafesProjectType) => {
  return type === DafesProjectType.art ? {
    background: '#151514',
    color: '#fff'
  } : {
    background: ' #F6C744',
    color: '#151514'
  }
}


const isNewDafesChoiceCompetition = (competition?: Competition): boolean => {

  const competitionType = Number(competition?.competitionType);

  if (isNewDafesChoiceCompetitionType(competitionType)) {
    return true;
  }

  if (competitionType === COMPETITION_TYPE.RatingArt) {
    return true;
  }

  if (competitionType === COMPETITION_TYPE.Rating) {
    return true;
  }

  const ratingProjectType = Number(competition?.ratingSettings?.ratingProjectType);
  return ratingProjectType >= DafesProjectType.art;
};

const DAFES_CATEGORY_LABELS: Record<DafesProjectType, string> = {
  [DafesProjectType.design]: 'DESIGN',
  [DafesProjectType.art]: 'ART',
  [DafesProjectType.fashion]: 'FASHION',
  [DafesProjectType.education]: 'EDUCATION',
  [DafesProjectType.startups]: 'STARTUPS',
  [DafesProjectType.dafesPlus]: 'DAFES+',
};

type DafesBadgeTexts = {
  coverLine1: string;
  coverLine2: string;
  plateText: string;
};

const getDafesProjectType = (type?: number): DafesProjectType => {
  if (type !== undefined && type in DAFES_CATEGORY_LABELS) {
    return type as DafesProjectType;
  }
  return DafesProjectType.design;
};

const getDafesBadgeTexts = (type: DafesProjectType, language: string): DafesBadgeTexts => {
  const isRu = language === 'ru';
  const category = DAFES_CATEGORY_LABELS[type];

  if (type === DafesProjectType.art) {
    return {
      coverLine1: 'BEST',
      coverLine2: 'ART',
      plateText: isRu ? 'BEST ART' : 'BEST ART',
    };
  }

  if (type === DafesProjectType.dafesPlus) {
    return {
      coverLine1: 'BEST',
      coverLine2: 'DAFES+',
      plateText: 'DAFES+',
    };
  }

  return {
    coverLine1: 'BEST',
    coverLine2: category,
    plateText: `BEST ${category}`,
  };
};

type RatingTypes = {
  competition?: Competition;
  isPlate?: boolean;
  isGridPlate?: boolean;
  onhoverPlate?: boolean;
  isCompetitionPage?: boolean
};

export const RatingImgGenerate = ({
  competition,
  isPlate,
  isGridPlate,
  onhoverPlate,
  isCompetitionPage
}: RatingTypes) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const [monthName, setMonthName] = useState(0);
  const [yearName, setYearName] = useState(2024);

  
  useEffect(() => {
    if (competition) {
      setMonthName(
        //@ts-ignore
        new Intl.DateTimeFormat(language, { month: "long" }).format(
           //@ts-ignore
          new Date(2024, competition?.ratingSettings?.month)
        )
      );
      //@ts-ignore
      setYearName(competition?.ratingSettings?.year);
    }
  }, [competition, language]);

  const isNewDafesChoice = useMemo(
    () => isNewDafesChoiceCompetition(competition),
    [competition]
  );

  const competitionType = useMemo(() => {
    return getDafesProjectType(competition?.ratingSettings?.ratingProjectType)
  } , [competition])

  const badgeTexts = useMemo(
    () => getDafesBadgeTexts(competitionType, language),
    [competitionType, language]
  );

  const topText = useMemo(() => {
    return competitionType === DafesProjectType.art ? 'BEST ART' : 'BEST'
  } , [competitionType])

  const isNewCoverDesign = useMemo(
    () => isNewDafesCoverDesign(competition),
    [competition]
  )

  const plateHoverStyle = {
    opacity: onhoverPlate ? 0 : 1,
    visibility: onhoverPlate ? 'hidden' : 'visible',
    transition: isGridPlate ? 'opacity 0.1s ease, visibility 0.3s ease' : 'opacity 0.3s ease, visibility 0.3s ease'
  } as const;

  const isDafesPlusType = competitionType === DafesProjectType.dafesPlus;
  const newPlateAccentColor = getCoverBottomColor(competitionType);
  const newPlateBottomColor = isDafesPlusType ? DAFES_PLUS_BOTTOM_COLOR : newPlateAccentColor;

  if (isPlate || isGridPlate) {
    if (isNewCoverDesign) {
      return (
        <PlateContainer style={plateHoverStyle} isGridPlate={isGridPlate}>
          <PlateTopSection isGridPlate={isGridPlate}>
            {isDafesPlusType ? (
              <>
                <PlateChoiceText isGridPlate={isGridPlate}>{t('competition.dafes_plus_line1')}</PlateChoiceText>
                <PlateBestText isGridPlate={isGridPlate} $accentColor={Colors.white}>
                  {t('competition.dafes_plus_line2')}
                </PlateBestText>
              </>
            ) : (
              <>
                <PlateChoiceText isGridPlate={isGridPlate}>{t('competition.dafes_choice')}</PlateChoiceText>
                <PlateBestText isGridPlate={isGridPlate} $accentColor={newPlateAccentColor}>
                  {DAFES_CATEGORY_LABELS[competitionType]}
                </PlateBestText>
              </>
            )}
          </PlateTopSection>
          <PlateBottomSection isGridPlate={isGridPlate} $accentColor={newPlateBottomColor}>
            <PlateText isGridPlate={isGridPlate}>{monthName} {yearName}</PlateText>
          </PlateBottomSection>
        </PlateContainer>
      );
    }

    if (isGridPlate) {
      return (
        <GridPlateContainer $isNewDafes={isNewDafesChoice} style={plateHoverStyle}>
          <GridTopSection {...(isNewDafesChoice ? DAFES_TOP_BLOCK_STYLES : getTopBlockStyles(competitionType))}>
            <GridBestText $isNewDafes={isNewDafesChoice}>{isNewDafesChoice ? badgeTexts.plateText : topText}</GridBestText>
          </GridTopSection>
          <GridBottomSection
           //@ts-ignore
            background={isNewDafesChoice ? DAFES_CHOICE_BOTTOM_COLOR : getMonthColor(competition?.ratingSettings?.month)}
          >
            <GridText $isNewDafes={isNewDafesChoice}>{monthName}</GridText>
            <GridText $isNewDafes={isNewDafesChoice}>{yearName}</GridText>
          </GridBottomSection>
        </GridPlateContainer>
      );
    }

    return (
      <LegacyPlateContainer $isNewDafes={isNewDafesChoice} style={plateHoverStyle}>
        <LegacyPlateTopSection $isNewDafes={isNewDafesChoice} {...(isNewDafesChoice ? DAFES_TOP_BLOCK_STYLES : getTopBlockStyles(competitionType))}>
          <LegacyPlateBestText $isNewDafes={isNewDafesChoice}>
            {isNewDafesChoice ? badgeTexts.plateText : topText}
          </LegacyPlateBestText>
        </LegacyPlateTopSection>
        <LegacyPlateBottomSection
          $isNewDafes={isNewDafesChoice}
          //@ts-ignore
          background={isNewDafesChoice ? DAFES_CHOICE_BOTTOM_COLOR : getMonthColor(competition?.ratingSettings?.month)}
        >
          <LegacyPlateText $isNewDafes={isNewDafesChoice}>{monthName}</LegacyPlateText>
          <LegacyPlateText $isNewDafes={isNewDafesChoice}>{yearName}</LegacyPlateText>
        </LegacyPlateBottomSection>
      </LegacyPlateContainer>
    );
  }

    if (!isNewCoverDesign) {
      return (
        <Container isCompetitionPage={isCompetitionPage}>
          <LegacyTopSection
            isCompetitionPage={isCompetitionPage}
            $isNewDafesChoice={isNewDafesChoice}
            {...(isNewDafesChoice ? DAFES_TOP_BLOCK_STYLES : getTopBlockStyles(competitionType))}
          >
            {isNewDafesChoice ? (
              <>
                <LegacyDafesCoverBestText>{badgeTexts.coverLine1}</LegacyDafesCoverBestText>
                <LegacyDafesCoverBestText>{badgeTexts.coverLine2}</LegacyDafesCoverBestText>
              </>
            ) : (
              <BestText isCompetitionPage={isCompetitionPage}>{topText}</BestText>
            )}
          </LegacyTopSection>
          <LegacyBottomSection
            //@ts-ignore
            background={isNewDafesChoice ? DAFES_CHOICE_BOTTOM_COLOR : getMonthColor(competition?.ratingSettings?.month)}
            isCompetitionPage={isCompetitionPage}
          >
            {isNewDafesChoice ? (
              <>
                <LegacyDafesCoverText>{monthName}</LegacyDafesCoverText>
                <LegacyDafesCoverText>{yearName}</LegacyDafesCoverText>
              </>
            ) : (
              <>
                <Text isCompetitionPage={isCompetitionPage}>{monthName}</Text>
                <Text isCompetitionPage={isCompetitionPage}>{yearName}</Text>
              </>
            )}
          </LegacyBottomSection>
        </Container>
      );
    }

    return (
      <Container isCompetitionPage={isCompetitionPage}>
        <TopSection
          isCompetitionPage={isCompetitionPage}
          $isNewDafesChoice={isNewDafesChoice}
          color={Colors.gal}
        >
          <CoverDafesLogo>
            <CoverDafesIcon />
          </CoverDafesLogo>
          <CoverTopTexts>
            {isDafesPlusType ? (
              <>
                <DafesCoverBestText>{t('competition.dafes_plus_line1')}</DafesCoverBestText>
                <DafesCoverCategoryText $color={Colors.white}>{t('competition.dafes_plus_line2')}</DafesCoverCategoryText>
              </>
            ) : (
              <>
                <DafesCoverBestText>{t('competition.dafes_choice')}</DafesCoverBestText>
                <DafesCoverCategoryText $color={getCoverBottomColor(competitionType)}>
                  {DAFES_CATEGORY_LABELS[competitionType]}
                </DafesCoverCategoryText>
              </>
            )}
          </CoverTopTexts>
        </TopSection>
        <BottomSection
          background={isDafesPlusType ? DAFES_PLUS_BOTTOM_COLOR : getCoverBottomColor(competitionType)}
          isCompetitionPage={isCompetitionPage}
        >
          <DafesCoverText>{monthName}</DafesCoverText>
          <DafesCoverText>{yearName}</DafesCoverText>
        </BottomSection>
      </Container>
    );

};
import { API, Competition } from "@brg/api";
import { Colors, FlexBox, MEDIA } from "@brg/ui";
import { COMPETITION_TYPE, isNewDafesChoiceCompetitionType } from "_competition/const";
import { DafesProjectType } from "_competition/pages/AllCompetitionsPage/types";
import { LayoutConst } from "core";
import { FC, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import {STATUSES} from "../../../../../_competition/const";
import { CoverDafesIcon } from "./CoverDafesIcon";

export const Container = styled.div<{isCompetitionPage?: boolean}>`
  width: 270px;
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;

 ${({ isCompetitionPage }) => isCompetitionPage && css`
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      width: 204px;
    }
 `}
 
  @media (max-width: ${LayoutConst.screen.l_12}px) {
    width: 204px;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    width: 168px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    width: 168px;
  }
  ${({ isCompetitionPage }) => isCompetitionPage && css`
   @media (max-width: ${LayoutConst.screen.md}px) {
    width: 100%;
  }
 `}
  @media (max-width: 768px) {
    width: 174px;
    height: 100%;
    min-height: 243px;
  }
  @media (max-width: ${LayoutConst.screen.s + "px"}) {
    height: ${LayoutConst.competitionCard.s.h + "px"};
    width: ${(LayoutConst.competitionCard.s.w - 4) / 2 + "px"};
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {

    ${() => {
      const width = 100;
      const padding = 20;
      const calculatedWidth = `calc(((${width}vw - ${padding}px) - 4px) / 2)`;
      const calculatedHeight = `calc((${width}vw - ${padding}px) * 0.680)`;
      return css`
        width: ${calculatedWidth};
        height: ${calculatedHeight};
        max-width: ${calculatedWidth};
        max-height: ${calculatedHeight};
        min-width: ${calculatedWidth};
        min-height: ${calculatedHeight};
        img {
          object-fit: cover;
        }
      `;
    }}
  }
`;

export const TopSection = styled.div<{background?: string, color?: string, isCompetitionPage?: boolean, $isNewDafesChoice?: boolean}>`
  background-color: ${Colors.galBlack100};
  color: ${({ color }) => color};
  flex: 1;
  display: flex;
  padding: 24px 24px 6px 32px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
    gap: 10px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    padding: 16px 16px 4px 16px;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    padding: 16px 16px 4px 16px;
  }

  @media (max-width: 500px) {
    padding: 12px 12px 4px 12px;
  }
`;
export const CoverDafesLogo = styled.div`
  width: 100px;
  height: 22px;
  flex-shrink: 0;
  align-self: flex-start;

  svg {
    display: block;
    width: 100%;
    height: 100%;
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 80px;
    height: 17px;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    width: 64px;
    height: 14px;
  }
`;
export const BottomSection = styled.div<{ background: string, isCompetitionPage?: boolean }>`
  background-color: ${({ background }) => background};
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 24px 24px 32px 32px;
  justify-content: center;
  align-items: flex-start;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    padding: 24px 16px 32px 16px;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    padding: 16px 16px 32px 16px;
  }

  @media (max-width: 500px) {
    padding: 12px 16px 32px 16px;
  }
`;
export const BestText = styled.div<{isCompetitionPage?: boolean}>`
  font-size: 70px;
  font-weight: 500;
  line-height: 65px; /* 92.857% */
  text-transform: uppercase;
  color: inherit;
  font-family: 'Druk Cy', sans-serif;
  font-feature-settings: 'liga' off, 'clig' off;
   ${({ isCompetitionPage }) => isCompetitionPage && css`
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
       font-size: 59px;
        font-weight: 500;
        line-height: 54px;
      }
  `}
  @media (max-width: ${LayoutConst.screen.l_12}px) {
      font-size: 59px;
        font-weight: 500;
        line-height: 54px;
    }
  @media (max-width: ${LayoutConst.screen.m + "px"}){
    font-size: 45px;
    font-weight: 500;
    line-height: 45px;
  }
   @media (max-width: ${LayoutConst.screen.s - 1 + "px"}){
            font-size: 49px;
        font-weight: 500;
        line-height: 49px;
    }

  }
`;

export const CoverTopTexts = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
`;

const coverTopTextStyles = css`
  text-align: right;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: "HSE Condensed", "HSE Sans", sans-serif;
  font-size: 62px;
  font-style: normal;
  font-weight: 500;
  line-height: 62px;
  text-transform: uppercase;
  width: 100%;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 50px;
    line-height: 45px;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    font-size: 39px;
    line-height: 34px;
  }

  @media (max-width: 950px) {
    font-size: 37px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 60px;
    line-height: 60px;
  }

  @media (max-width: 500px) {
    font-size: 35px;
    line-height: 30px;
  }
`;

export const DafesCoverBestText = styled.div`
  ${coverTopTextStyles}
  color: ${Colors.gal};
`;

export const DafesCoverCategoryText = styled.div<{ $color: string }>`
  ${coverTopTextStyles}
  color: ${({ $color }) => $color};
`;
export const Text = styled.div<{isCompetitionPage?: boolean}>`
  font-size: 70px;
  font-weight: 500;
  line-height: 65px; /* 92.857% */
  text-transform: uppercase;
  color: #fff;
  font-family: 'Druk Cy', sans-serif;
  font-feature-settings: 'liga' off, 'clig' off;
   ${({ isCompetitionPage }) => isCompetitionPage && css`
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 59px;
        font-weight: 500;
        line-height: 54px
      }
  `}
  @media (max-width: ${LayoutConst.screen.l_12}px) {
    font-size: 59px;
        font-weight: 500;
        line-height: 54px;
    }
 @media (max-width: ${LayoutConst.screen.m + "px"}){
    font-size: 45px;
    font-weight: 500;
    line-height: 45px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}){
            font-size: 49px;
        font-weight: 500;
        line-height: 49px;
    }

  }
      
`;

const NEW_COVER_FROM_YEAR = 2026;
const NEW_COVER_FROM_MONTH = 5;

const isNewDafesCoverDesign = (competition?: Competition): boolean => {
  const year = Number(competition?.ratingSettings?.year);
  const month = Number(competition?.ratingSettings?.month);

  if (!Number.isFinite(year) || !Number.isFinite(month)) {
    return false;
  }

  return year > NEW_COVER_FROM_YEAR || (year === NEW_COVER_FROM_YEAR && month >= NEW_COVER_FROM_MONTH);
};

export const LegacyTopSection = styled.div<{background?: string, color?: string, isCompetitionPage?: boolean, $isNewDafesChoice?: boolean}>`
  background-color: ${({ background }) => background};
  color: ${({ color }) => color};
  flex: 1;
  display: flex;
  flex-direction: ${({ $isNewDafesChoice }) => $isNewDafesChoice ? 'column' : 'row'};
  justify-content: flex-end;
  align-items: flex-end;
  padding: 24px 24px 16px;
  ${({ isCompetitionPage }) => isCompetitionPage && css`
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      padding: 20px 20px 12px;
    }
 `}
  @media (max-width: ${LayoutConst.screen.l_12}px) {
    padding: 20px 20px 12px;
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    padding: 8px 16px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
    padding: 16px 16px 12px;
  }
`;

export const LegacyBottomSection = styled.div<{ background: string, isCompetitionPage?: boolean }>`
  background-color: ${({ background }) => background};
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  padding: 20px 24px 16px;
   ${({ isCompetitionPage }) => isCompetitionPage && css`
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        padding: 14px 20px 12px;
      }
  `}
  @media (max-width: ${LayoutConst.screen.l_12}px) {
    padding: 14px 20px 12px;
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    padding: 8px 16px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
    padding: 16px 18px 16px;
  }
  @media (max-width: ${LayoutConst.screen.xsm + "px"}) {
    padding: 10px 18px 10px;
  }
`;

export const LegacyDafesCoverBestText = styled.div`
  font-size: 70px;
  font-weight: 500;
  line-height: 65px;
  text-transform: uppercase;
  color: inherit;
  font-family: 'Druk Cy', sans-serif;
  font-feature-settings: 'liga' off, 'clig' off;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 53px;
    line-height: 50px;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    font-size: 46px;
    line-height: 45px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
    font-size: 40px;
    line-height: 35px;
  }
`;

export const LegacyDafesCoverText = styled.div`
  font-size: 70px;
  font-weight: 500;
  line-height: 65px;
  text-transform: uppercase;
  color: #fff;
  font-family: 'Druk Cy', sans-serif;
  font-feature-settings: 'liga' off, 'clig' off;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 53px;
    line-height: 50px;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    font-size: 46px;
    line-height: 45px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
    font-size: 40px;
    line-height: 35px;
  }
`;
export const DafesCoverText = styled.div`
  color: ${Colors.gal};
  text-align: right;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: "HSE Condensed", "HSE Sans", sans-serif;
  font-size: 62px;
  font-style: normal;
  font-weight: 500;
  line-height: 55px;
  text-transform: uppercase;
  width: 100%;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 50px;
    line-height: 45px;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    font-size: 39px;
    line-height: 39px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 60px;
    line-height: 60px;
  }

  @media (max-width: 500px) {
    font-size: 35px;
    line-height: 35px;
  }
`;
export const PlateContainer = styled(FlexBox)<{isGridPlate?: boolean}>`
  width: ${({ isGridPlate }) => (isGridPlate ? '80px' : '160px')};
  height: ${({ isGridPlate }) => (isGridPlate ? '80px' : '160px')};
  flex-direction: column;
  flex-shrink: 0;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    width: ${({ isGridPlate }) => (isGridPlate ? '60px' : '120px')};
    height: ${({ isGridPlate }) => (isGridPlate ? '60px' : '120px')};
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    width: ${({ isGridPlate }) => (isGridPlate ? '60px' : '100px')};
    height: ${({ isGridPlate }) => (isGridPlate ? '60px' : '100px')};
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    width: ${({ isGridPlate }) => (isGridPlate ? '56px' : '88px')};
    height: ${({ isGridPlate }) => (isGridPlate ? '56px' : '88px')};
  }
`;
export const PlateTopSection = styled(FlexBox)<{isGridPlate?: boolean}>`
  height: ${({ isGridPlate }) => (isGridPlate ? '50px' : '100px')};
  flex: none;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background: ${Colors.galBlack100};
  color: ${Colors.white};
  padding: ${({ isGridPlate }) => (isGridPlate ? '8px 6px 4px 6px' : '16px 12px 8px 12px')};

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    height: ${({ isGridPlate }) => (isGridPlate ? '39px' : '75px')};
    padding: ${({ isGridPlate }) => (isGridPlate ? '6px 5px 3px 5px' : '12px 10px 6px 10px')};
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    height: ${({ isGridPlate }) => (isGridPlate ? '39px' : '63px')};
    padding: ${({ isGridPlate }) => (isGridPlate ? '6px 5px 3px 5px' : '10px 8px 5px 8px')};
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    height: ${({ isGridPlate }) => (isGridPlate ? '32px' : '54px')};
    padding: ${({ isGridPlate }) => (isGridPlate ? '4px 3.333px 2px 3.333px' : '8px 8px 4px 8px')};
  }
`;
const plateTopTextStyles = css`
  text-align: right;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: "HSE Condensed", "HSE Sans", sans-serif;
  font-size: 19px;
  font-style: normal;
  font-weight: 500;
  line-height: 19px;
  text-transform: uppercase;
  white-space: nowrap;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 14px;
    line-height: 14.012px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 9.333px;
    line-height: 9.342px;
  }
`;

const plateTopTextProjectStyles = css`
  font-size: 38px;
  line-height: 38px;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 28px;
    line-height: 28px;
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 24px;
    line-height: 24px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 16px;
    line-height: 16px;
  }
`;

export const PlateChoiceText = styled.div<{isGridPlate?: boolean}>`
  color: ${Colors.white};
  ${plateTopTextStyles};
  ${({ isGridPlate }) => !isGridPlate && plateTopTextProjectStyles};

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: ${({ isGridPlate }) => (isGridPlate ? '11px' : '16px')};
    line-height: ${({ isGridPlate }) => (isGridPlate ? '11px' : '16px')};
  }
  
`;

export const PlateBestText = styled.div<{ isGridPlate?: boolean; $accentColor: string }>`
  color: ${({ $accentColor }) => $accentColor};
  ${plateTopTextStyles};
  ${({ isGridPlate }) => !isGridPlate && plateTopTextProjectStyles};

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: ${({ isGridPlate }) => (isGridPlate ? '11px' : '16px')};
    line-height: ${({ isGridPlate }) => (isGridPlate ? '11px' : '16px')};
  }
`;
export const PlateBottomSection = styled.div<{ isGridPlate?: boolean; $accentColor: string }>`
  height: ${({ isGridPlate }) => (isGridPlate ? '30px' : '60px')};
  flex: none;
  background-color: ${({ $accentColor }) => $accentColor};
  display: flex;
  padding: ${({ isGridPlate }) => (isGridPlate ? '9px 6px 8px 6px' : '18px 12px 16px 12px')};
  justify-content: center;
  align-items: flex-start;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    height: ${({ isGridPlate }) => (isGridPlate ? '21px' : '45px')};
    padding: ${({ isGridPlate }) => (isGridPlate ? '7px 5px' : '14px 10px')};
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    height: ${({ isGridPlate }) => (isGridPlate ? '21px' : '37px')};
    padding: ${({ isGridPlate }) => (isGridPlate ? '7px 5px' : '12px 8px')};
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    height: ${({ isGridPlate }) => (isGridPlate ? '24px' : '34px')};
    padding: ${({ isGridPlate }) => (isGridPlate ? '4.667px 3.333px' : '8px 8px 4px 8px')};
  }
`;

export const PlateText = styled.div<{isGridPlate?: boolean}>`
  color: ${Colors.white};
  text-align: right;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: "HSE Condensed", "HSE Sans", sans-serif;
  font-size: ${({ isGridPlate }) => (isGridPlate ? '15px' : '30px')};
  font-style: normal;
  font-weight: 500;
  line-height: ${({ isGridPlate }) => (isGridPlate ? '15px' : '30px')};
  text-transform: uppercase;
  white-space: nowrap;
  width: 100%;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: ${({ isGridPlate }) => (isGridPlate ? '11px' : '22px')};
    line-height: ${({ isGridPlate }) => (isGridPlate ? '11px' : '22px')};
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: ${({ isGridPlate }) => (isGridPlate ? '11px' : '19px')};
    line-height: ${({ isGridPlate }) => (isGridPlate ? '11px' : '19px')};
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: ${({ isGridPlate }) => (isGridPlate ? '11px' : '16px')};
    line-height: ${({ isGridPlate }) => (isGridPlate ? '11px' : '16px')};
  }
`;

const LegacyPlateContainer = styled(FlexBox)<{ $isNewDafes?: boolean }>`
  width: 160px;
  height: ${({ $isNewDafes }) => ($isNewDafes ? '160px' : '172px')};
  flex-direction: column;
  @media (max-width: ${LayoutConst.screen.mac13}px) {
    width: 120px;
    height: ${({ $isNewDafes }) => ($isNewDafes ? '120px' : '129px')};
  }
  @media (max-width: ${LayoutConst.screen.m + "px"}) {
    width: 100px;
    height: ${({ $isNewDafes }) => ($isNewDafes ? '100px' : '107px')};
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
    width: 88px;
    height: ${({ $isNewDafes }) => ($isNewDafes ? '88px' : '94px')};
  }
`;
const LegacyPlateTopSection = styled(FlexBox)<{background?: string, color?: string, $isNewDafes?: boolean}>`
  height: 50%;
  background: ${({ background }) => background};
  color: ${({ color }) => color};
  padding: ${({ $isNewDafes }) => $isNewDafes ? '10px 16px 5px' : '16px 16px 8px'};
  justify-content: flex-end;
  flex: 1;
  @media (max-width: ${LayoutConst.screen.m + "px"}) {
   padding: 8px 10px 4px 10px;
  }
`;
const LegacyPlateBottomSection = styled.div<{ background: string, $isNewDafes?: boolean }>`
  background-color: ${({ background }) => background};
  padding: 16px;
  flex: 2;
  @media (max-width: ${LayoutConst.screen.m + "px"}) {
    padding: 10px;
  }
  @media ${MEDIA.MOBILE} {
    padding: ${({ $isNewDafes }) => $isNewDafes ? '8px' : '10px'};
  }
`;
const LegacyPlateBestText = styled.div<{ $compact?: boolean, $isNewDafes?: boolean }>`
  font-size: ${({ $compact, $isNewDafes }) => $isNewDafes || $compact ? '30px' : '40px'};
  line-height: ${({ $isNewDafes }) => $isNewDafes ? '40px' : '92.857%'};
  font-weight: 500;
  text-transform: uppercase;
  text-align: right;
  color: inherit;
  font-family: 'Druk Cy', sans-serif;
  font-feature-settings: 'liga' off, 'clig' off;
  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: ${({ $isNewDafes }) => $isNewDafes ? '23px' : '38px'};
    line-height: ${({ $isNewDafes }) => $isNewDafes ? '30px' : '92.857%'};
    }
  @media (max-width: ${LayoutConst.screen.l}){
      font-size: ${({ $isNewDafes }) => $isNewDafes ? '19px' : '28px'};
      line-height: ${({ $isNewDafes }) => $isNewDafes ? '25px' : '92.857%'};
    }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}){
        font-size: ${({ $isNewDafes }) => $isNewDafes ? '17px' : '27px'};
        line-height: ${({ $isNewDafes }) => $isNewDafes ? '22px' : '92.857%'};
      }
  }
`;
const LegacyPlateText = styled.div<{ $isNewDafes?: boolean }>`
  font-size: ${({ $isNewDafes }) => $isNewDafes ? '43px' : '40px'};
  font-weight: 500;
  line-height: ${({ $isNewDafes }) => $isNewDafes ? '40px' : '92.857%'};
  text-transform: uppercase;
  text-align: right;
  color: #fff;
  font-family: 'Druk Cy', sans-serif;
  font-feature-settings: 'liga' off, 'clig' off;
  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: ${({ $isNewDafes }) => $isNewDafes ? '32px' : '38px'};
  line-height: ${({ $isNewDafes }) => $isNewDafes ? '30px' : '92.857%'};
  }
  @media (max-width: ${LayoutConst.screen.l}){
      font-size: ${({ $isNewDafes }) => $isNewDafes ? '27px' : '28px'};
      line-height: ${({ $isNewDafes }) => $isNewDafes ? '25px' : '92.857%'};
    }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}){
        font-size: ${({ $isNewDafes }) => $isNewDafes ? '24px' : '27px'};
        line-height: ${({ $isNewDafes }) => $isNewDafes ? '22px' : '92.857%'};
      }
  }
      
`;

export const GridPlateContainer = styled(FlexBox)<{ $isNewDafes?: boolean }>`
  width: 80px;
  height: ${({ $isNewDafes }) => ($isNewDafes ? '80px' : '86px')};
  flex-direction: column;
  @media (max-width: ${LayoutConst.screen.mac13}px) {
    width: 60px;
    height: ${({ $isNewDafes }) => ($isNewDafes ? '60px' : '64px')};
  }
  @media (max-width: ${LayoutConst.screen.l}px) {
    width: 60px;
    height: ${({ $isNewDafes }) => ($isNewDafes ? '60px' : '64px')};
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
    width: 56px;
    height: ${({ $isNewDafes }) => ($isNewDafes ? '56px' : '63px')};
  }
`;


export const GridTopSection = styled(FlexBox)<{ background?: string, color?: string}>`
  height: 30px;
  background: ${({ background }) => background};
  color: ${({ color }) => color};
  padding: 6px 6px 4px;
  justify-content: flex-end;
  flex: 1;
  @media (max-width: ${LayoutConst.screen.l_12}px) {
  }
  @media (max-width: ${LayoutConst.screen.m + "px"}) {
   padding: 4px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
   padding: 6px 6px 4px;
  }
   @media (max-width: ${LayoutConst.screen.sm + "px"}) {
     padding: 5px 4px 2px;
  }
`;

export const GridBottomSection = styled.div<{ background: string }>`
  background-color: ${({ background }) => background};
  padding: 6px;
  flex: 2;
  @media (max-width: ${LayoutConst.screen.l_12}px) {
  
  }
  @media (max-width: ${LayoutConst.screen.m + "px"}) {
    padding: 4px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}) {
    padding: 6px;
  }
  @media (max-width: ${LayoutConst.screen.sm + "px"}) {
     padding: 4px;
  }
`;

export const GridBestText = styled.div<{ $isNewDafes?: boolean }>`
  font-size: ${({ $isNewDafes }) => $isNewDafes ? '15px' : '22px'};
  line-height: ${({ $isNewDafes }) => $isNewDafes ? '19px' : '92.857%'};
  font-weight: 500;
  text-transform: uppercase;
  text-align: right;
  color: inherit;
  font-family: 'Druk Cy', sans-serif;
  font-feature-settings: 'liga' off, 'clig' off;
  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: ${({ $isNewDafes }) => $isNewDafes ? '11px' : '16px'};
    line-height: ${({ $isNewDafes }) => $isNewDafes ? '14px' : '92.857%'};
  }
  @media (max-width: ${LayoutConst.screen.l}){
    font-size: ${({ $isNewDafes }) => $isNewDafes ? '10px' : '14px'};
    line-height: ${({ $isNewDafes }) => $isNewDafes ? '14px' : '92.857%'};
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}){
    font-size: ${({ $isNewDafes }) => $isNewDafes ? '8px' : '11px'};
    line-height: ${({ $isNewDafes }) => $isNewDafes ? '10px' : '92.857%'};
      }
  }

  }
`;

export const GridText = styled.div<{ $isNewDafes?: boolean }>`
  font-size: ${({ $isNewDafes }) => $isNewDafes ? '21px' : '22px'};
  font-weight: 500;
  line-height: ${({ $isNewDafes }) => $isNewDafes ? '19px' : '92.857%'};
  text-transform: uppercase;
  text-align: right;
  color: #fff;
  font-family: 'Druk Cy', sans-serif;
  font-feature-settings: 'liga' off, 'clig' off;
  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: ${({ $isNewDafes }) => $isNewDafes ? '16px' : '21px'};
    line-height: ${({ $isNewDafes }) => $isNewDafes ? '14px' : '92.857%'};
  }
  @media (max-width: ${LayoutConst.screen.l}){
    font-size: ${({ $isNewDafes }) => $isNewDafes ? '15px' : '14px'};
    line-height: ${({ $isNewDafes }) => $isNewDafes ? '14px' : '92.857%'};
  }
  @media (max-width: ${LayoutConst.screen.s - 1 + "px"}){
    font-size: ${({ $isNewDafes }) => $isNewDafes ? '11px' : '22px'};
    line-height: ${({ $isNewDafes }) => $isNewDafes ? '10px' : '92.857%'};
      }
  }
      
`;

const DAFES_CHOICE_BOTTOM_COLOR = '#8E7CC3';
const DAFES_PLUS_BOTTOM_COLOR = '#2D2D2D';

const COVER_BOTTOM_COLORS: Record<DafesProjectType, string> = {
  [DafesProjectType.art]: '#FF6BFD',
  [DafesProjectType.fashion]: '#FF8B00',
  [DafesProjectType.design]: '#F00',
  [DafesProjectType.education]: '#5D98FF',
  [DafesProjectType.startups]: '#4EF100',
  [DafesProjectType.dafesPlus]: '#F00',
};

const getCoverBottomColor = (type: DafesProjectType): string => {
  return COVER_BOTTOM_COLORS[type] ?? COVER_BOTTOM_COLORS[DafesProjectType.design];
};

const DAFES_TOP_BLOCK_STYLES = {
  background: '#F6C744',
  color: '#151514',
};

enum MonthColors {
  Winter = "#8C6FDD",
  Sprint = "#EC5FB1",
  Summer = "#49A13F",
  Autumn = "#EB5829",
}

function getMonthColor(monthNumber: number): string {
  
  switch (monthNumber) {
    case 11:
    case 0:
    case 1:
      return MonthColors.Winter;
    case 2:
    case 3:
    case 4:
      return MonthColors.Sprint;
    case 5:
    case 6:
    case 7:
      return MonthColors.Summer;
    case 8:
    case 9:
    case 10:
      return MonthColors.Autumn;
    default:
      return "#000000";
  }
}

const getTopBlockStyles = (type: DafesProjectType) => {
  return type === DafesProjectType.art ? {
    background: '#151514',
    color: '#fff'
  } : {
    background: ' #F6C744',
    color: '#151514'
  }
}


const isNewDafesChoiceCompetition = (competition?: Competition): boolean => {

  const competitionType = Number(competition?.competitionType);

  if (isNewDafesChoiceCompetitionType(competitionType)) {
    return true;
  }

  if (competitionType === COMPETITION_TYPE.RatingArt) {
    return true;
  }

  if (competitionType === COMPETITION_TYPE.Rating) {
    return true;
  }

  const ratingProjectType = Number(competition?.ratingSettings?.ratingProjectType);
  return ratingProjectType >= DafesProjectType.art;
};

const DAFES_CATEGORY_LABELS: Record<DafesProjectType, string> = {
  [DafesProjectType.design]: 'DESIGN',
  [DafesProjectType.art]: 'ART',
  [DafesProjectType.fashion]: 'FASHION',
  [DafesProjectType.education]: 'EDUCATION',
  [DafesProjectType.startups]: 'STARTUPS',
  [DafesProjectType.dafesPlus]: 'DAFES+',
};

type DafesBadgeTexts = {
  coverLine1: string;
  coverLine2: string;
  plateText: string;
};

const getDafesProjectType = (type?: number): DafesProjectType => {
  if (type !== undefined && type in DAFES_CATEGORY_LABELS) {
    return type as DafesProjectType;
  }
  return DafesProjectType.design;
};

const getDafesBadgeTexts = (type: DafesProjectType, language: string): DafesBadgeTexts => {
  const isRu = language === 'ru';
  const category = DAFES_CATEGORY_LABELS[type];

  if (type === DafesProjectType.art) {
    return {
      coverLine1: 'BEST',
      coverLine2: 'ART',
      plateText: isRu ? 'BEST ART' : 'BEST ART',
    };
  }

  if (type === DafesProjectType.dafesPlus) {
    return {
      coverLine1: 'BEST',
      coverLine2: 'DAFES+',
      plateText: 'DAFES+',
    };
  }

  return {
    coverLine1: 'BEST',
    coverLine2: category,
    plateText: `BEST ${category}`,
  };
};

type RatingTypes = {
  competition?: Competition;
  isPlate?: boolean;
  isGridPlate?: boolean;
  onhoverPlate?: boolean;
  isCompetitionPage?: boolean
};

export const RatingImgGenerate = ({
  competition,
  isPlate,
  isGridPlate,
  onhoverPlate,
  isCompetitionPage
}: RatingTypes) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const [monthName, setMonthName] = useState(0);
  const [yearName, setYearName] = useState(2024);

  
  useEffect(() => {
    if (competition) {
      setMonthName(
        //@ts-ignore
        new Intl.DateTimeFormat(language, { month: "long" }).format(
           //@ts-ignore
          new Date(2024, competition?.ratingSettings?.month)
        )
      );
      //@ts-ignore
      setYearName(competition?.ratingSettings?.year);
    }
  }, [competition, language]);

  const isNewDafesChoice = useMemo(
    () => isNewDafesChoiceCompetition(competition),
    [competition]
  );

  const competitionType = useMemo(() => {
    return getDafesProjectType(competition?.ratingSettings?.ratingProjectType)
  } , [competition])

  const badgeTexts = useMemo(
    () => getDafesBadgeTexts(competitionType, language),
    [competitionType, language]
  );

  const topText = useMemo(() => {
    return competitionType === DafesProjectType.art ? 'BEST ART' : 'BEST'
  } , [competitionType])

  const isNewCoverDesign = useMemo(
    () => isNewDafesCoverDesign(competition),
    [competition]
  )

  const plateHoverStyle = {
    opacity: onhoverPlate ? 0 : 1,
    visibility: onhoverPlate ? 'hidden' : 'visible',
    transition: isGridPlate ? 'opacity 0.1s ease, visibility 0.3s ease' : 'opacity 0.3s ease, visibility 0.3s ease'
  } as const;

  const isDafesPlusType = competitionType === DafesProjectType.dafesPlus;
  const newPlateAccentColor = getCoverBottomColor(competitionType);
  const newPlateBottomColor = isDafesPlusType ? DAFES_PLUS_BOTTOM_COLOR : newPlateAccentColor;

  if (isPlate || isGridPlate) {
    if (isNewCoverDesign) {
      return (
        <PlateContainer style={plateHoverStyle} isGridPlate={isGridPlate}>
          <PlateTopSection isGridPlate={isGridPlate}>
            {isDafesPlusType ? (
              <>
                <PlateChoiceText isGridPlate={isGridPlate}>{t('competition.dafes_plus_line1')}</PlateChoiceText>
                <PlateBestText isGridPlate={isGridPlate} $accentColor={Colors.white}>
                  {t('competition.dafes_plus_line2')}
                </PlateBestText>
              </>
            ) : (
              <>
                <PlateChoiceText isGridPlate={isGridPlate}>{t('competition.dafes_choice')}</PlateChoiceText>
                <PlateBestText isGridPlate={isGridPlate} $accentColor={newPlateAccentColor}>
                  {DAFES_CATEGORY_LABELS[competitionType]}
                </PlateBestText>
              </>
            )}
          </PlateTopSection>
          <PlateBottomSection isGridPlate={isGridPlate} $accentColor={newPlateBottomColor}>
            <PlateText isGridPlate={isGridPlate}>{monthName} {yearName}</PlateText>
          </PlateBottomSection>
        </PlateContainer>
      );
    }

    if (isGridPlate) {
      return (
        <GridPlateContainer $isNewDafes={isNewDafesChoice} style={plateHoverStyle}>
          <GridTopSection {...(isNewDafesChoice ? DAFES_TOP_BLOCK_STYLES : getTopBlockStyles(competitionType))}>
            <GridBestText $isNewDafes={isNewDafesChoice}>{isNewDafesChoice ? badgeTexts.plateText : topText}</GridBestText>
          </GridTopSection>
          <GridBottomSection
           //@ts-ignore
            background={isNewDafesChoice ? DAFES_CHOICE_BOTTOM_COLOR : getMonthColor(competition?.ratingSettings?.month)}
          >
            <GridText $isNewDafes={isNewDafesChoice}>{monthName}</GridText>
            <GridText $isNewDafes={isNewDafesChoice}>{yearName}</GridText>
          </GridBottomSection>
        </GridPlateContainer>
      );
    }

    return (
      <LegacyPlateContainer $isNewDafes={isNewDafesChoice} style={plateHoverStyle}>
        <LegacyPlateTopSection $isNewDafes={isNewDafesChoice} {...(isNewDafesChoice ? DAFES_TOP_BLOCK_STYLES : getTopBlockStyles(competitionType))}>
          <LegacyPlateBestText $isNewDafes={isNewDafesChoice}>
            {isNewDafesChoice ? badgeTexts.plateText : topText}
          </LegacyPlateBestText>
        </LegacyPlateTopSection>
        <LegacyPlateBottomSection
          $isNewDafes={isNewDafesChoice}
          //@ts-ignore
          background={isNewDafesChoice ? DAFES_CHOICE_BOTTOM_COLOR : getMonthColor(competition?.ratingSettings?.month)}
        >
          <LegacyPlateText $isNewDafes={isNewDafesChoice}>{monthName}</LegacyPlateText>
          <LegacyPlateText $isNewDafes={isNewDafesChoice}>{yearName}</LegacyPlateText>
        </LegacyPlateBottomSection>
      </LegacyPlateContainer>
    );
  }

    if (!isNewCoverDesign) {
      return (
        <Container isCompetitionPage={isCompetitionPage}>
          <LegacyTopSection
            isCompetitionPage={isCompetitionPage}
            $isNewDafesChoice={isNewDafesChoice}
            {...(isNewDafesChoice ? DAFES_TOP_BLOCK_STYLES : getTopBlockStyles(competitionType))}
          >
            {isNewDafesChoice ? (
              <>
                <LegacyDafesCoverBestText>{badgeTexts.coverLine1}</LegacyDafesCoverBestText>
                <LegacyDafesCoverBestText>{badgeTexts.coverLine2}</LegacyDafesCoverBestText>
              </>
            ) : (
              <BestText isCompetitionPage={isCompetitionPage}>{topText}</BestText>
            )}
          </LegacyTopSection>
          <LegacyBottomSection
            //@ts-ignore
            background={isNewDafesChoice ? DAFES_CHOICE_BOTTOM_COLOR : getMonthColor(competition?.ratingSettings?.month)}
            isCompetitionPage={isCompetitionPage}
          >
            {isNewDafesChoice ? (
              <>
                <LegacyDafesCoverText>{monthName}</LegacyDafesCoverText>
                <LegacyDafesCoverText>{yearName}</LegacyDafesCoverText>
              </>
            ) : (
              <>
                <Text isCompetitionPage={isCompetitionPage}>{monthName}</Text>
                <Text isCompetitionPage={isCompetitionPage}>{yearName}</Text>
              </>
            )}
          </LegacyBottomSection>
        </Container>
      );
    }

    return (
      <Container isCompetitionPage={isCompetitionPage}>
        <TopSection
          isCompetitionPage={isCompetitionPage}
          $isNewDafesChoice={isNewDafesChoice}
          color={Colors.gal}
        >
          <CoverDafesLogo>
            <CoverDafesIcon />
          </CoverDafesLogo>
          <CoverTopTexts>
            {isDafesPlusType ? (
              <>
                <DafesCoverBestText>{t('competition.dafes_plus_line1')}</DafesCoverBestText>
                <DafesCoverCategoryText $color={Colors.white}>{t('competition.dafes_plus_line2')}</DafesCoverCategoryText>
              </>
            ) : (
              <>
                <DafesCoverBestText>{t('competition.dafes_choice')}</DafesCoverBestText>
                <DafesCoverCategoryText $color={getCoverBottomColor(competitionType)}>
                  {DAFES_CATEGORY_LABELS[competitionType]}
                </DafesCoverCategoryText>
              </>
            )}
          </CoverTopTexts>
        </TopSection>
        <BottomSection
          background={isDafesPlusType ? DAFES_PLUS_BOTTOM_COLOR : getCoverBottomColor(competitionType)}
          isCompetitionPage={isCompetitionPage}
        >
          <DafesCoverText>{monthName}</DafesCoverText>
          <DafesCoverText>{yearName}</DafesCoverText>
        </BottomSection>
      </Container>
    );

};
